import angular from 'angular';

import PrettyNumberComponent from './pretty-number.cmpt';

export default angular
    .module('application.component.pretty-number', [])
    .component(PrettyNumberComponent.selector, PrettyNumberComponent);



// WEBPACK FOOTER //
// ./src/application/component/pretty-number/index.js